import translations from '../../static/translation'

const DEFAULT_LANG = 'EN'

const Translate = (value, lang = DEFAULT_LANG, subcheck = true) => (
    (
        lang === DEFAULT_LANG
            ? value
            : translations.hasOwnProperty(lang)
                ? translations[lang][value]
                : subcheck && Translate(
                    value,
                    lang.substr(0, 2),
                    false
                )
    )
    || value
)

export default Translate



// WEBPACK FOOTER //
// ./src/components/utils/Translate.js